import React, { useRef, useEffect } from 'react';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    videoSrc: string;
}

const ModalComponent: React.FC<ModalProps> = ({ isOpen, onClose, videoSrc }) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (isOpen && videoRef.current) {
            videoRef.current.play().catch((err) => {
                console.warn("Autoplay error:", err);
            });
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 ">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-7xl">
                <div className="aspect-video m-2 sm:m-2 md:m-2">
                    <video
                        ref={videoRef}
                        src={videoSrc}
                        className="w-full h-full object-cover rounded-3xl mb-4"
                        autoPlay loop muted playsInline
                        preload="auto"
                    />
                    <h2 className="text-xl font-semibold tracking-tight text-gray-900 mx-auto">
                        En los próximos días, el equipo de Mejora e Innovación, se pondrá en contacto contigo.
                    </h2>

                </div>
                {/**<div className="p-4 text-right">
                    <button onClick={onClose} className="rounded-md bg-[#D75313] px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-orange-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500">
                        Cerrar
                    </button>
                </div>**/}
            </div>
        </div>
    );
};

export default ModalComponent;